import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, class_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { News_NewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["LandingPage"];
    }
}

export function Page_$reflection() {
    return union_type("Home.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadNews", "NewsLoaded", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Home.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(News_NewsListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(News_NewsListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(NewsList) {
        super();
        this.NewsList = NewsList;
    }
}

export function Model_$reflection() {
    return record_type("Home.Types.Model", [], Model, () => [["NewsList", Remote$1_$reflection(Paginated$1_$reflection(News_NewsListItem_$reflection()))]]);
}

//# sourceMappingURL=Types.fs.js.map
